export default __webpack_public_path__ + "static/media/painscale_0.43eb7b1e.png";